module.exports = __webpack_public_path__ + "static/media/lamp-desk.a0ce3e21.svg";